import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DbCertificateProvider } from "../providers/database/db-certificate";
import { DbAttendeesProvider } from "../providers/database/db-attendees";
import { PDFProps } from "../client-dashboard/client-event-dashboard/client-modules/certificate/types/certificate";

@Component({
    selector: "app-certificate-download",
    templateUrl: "./certificate-download.component.html",
    styleUrls: ["./certificate-download.component.scss"],
})
export class CertificateDownloadComponent implements OnInit {
    isLoading: boolean = true;
    eventId: string;
    moduleId: string;
    attendeeId: string;
    attendee = null;
    pdfProps: PDFProps;
    showErrorPage: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private dbCertificate: DbCertificateProvider,
        private dbAttendees: DbAttendeesProvider,
    ) {}

    async ngOnInit() {
        this.eventId =
            this.route.pathFromRoot[1]["params"]["_value"]["eventId"];
        this.moduleId =
            this.route.pathFromRoot[1]["params"]["_value"]["moduleId"];
        this.attendeeId =
            this.route.pathFromRoot[1]["params"]["_value"]["attendeeId"];

        this.isLoading = true;

        const module = await this.dbCertificate.getModule(this.eventId, this.moduleId)
        if (!module || !module.exists && !module.data()?.pdfProps) {
            console.error('Module not found');
            this.isLoading = false;
            this.showErrorPage = true;
            return
        }

        this.pdfProps = module.data().pdfProps;

        this.dbAttendees.getAttendee(this.eventId, this.moduleId, this.attendeeId, (data) => {
            if (data && data.result) {
                this.attendee = data.result;
                this.isLoading = false;
                this.handlePDFDownload();
            } else {
                console.error('Attendee not found');
                this.isLoading = false;
                this.showErrorPage = true;
                return
            }
        });
    }

    handlePDFDownload() {
        const pdfOutput = this.dbCertificate.generateCertificatePDFOutput(this.pdfProps, this.attendee.name.trim())
        window.open(pdfOutput, '_self')
    }
}
